if (!customElements.get("formula-testimonial-spotlight")) {
  class FormulaTestimonialSpotlight extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;

      this.initialized = true;
      this.slides = Array.from(this.querySelectorAll("[data-testimonial-slide]"));
      this.dots = Array.from(this.querySelectorAll("[data-testimonial-dot]"));
      this.activeIndex = this.slides.findIndex((slide) => !slide.hidden);

      if (this.activeIndex < 0) {
        this.activeIndex = 0;
      }

      this.handleClick = this.handleClick.bind(this);
      this.handleDotKeydown = this.handleDotKeydown.bind(this);
      this.handleBlockSelect = this.handleBlockSelect.bind(this);

      this.addEventListener("click", this.handleClick);
      this.addEventListener("keydown", this.handleDotKeydown);
      this.addEventListener("shopify:block:select", this.handleBlockSelect);
    }

    disconnectedCallback() {
      this.removeEventListener("click", this.handleClick);
      this.removeEventListener("keydown", this.handleDotKeydown);
      this.removeEventListener("shopify:block:select", this.handleBlockSelect);
      this.initialized = false;
    }

    handleClick(event) {
      if (event.target.closest?.("[data-testimonial-previous]")) {
        const previousIndex = this.activeIndex === 0 ? this.slides.length - 1 : this.activeIndex - 1;
        this.selectSlide(previousIndex);
        return;
      }

      if (event.target.closest?.("[data-testimonial-next]")) {
        const nextIndex = this.activeIndex === this.slides.length - 1 ? 0 : this.activeIndex + 1;
        this.selectSlide(nextIndex);
        return;
      }

      const dot = event.target.closest?.("[data-testimonial-dot]");
      const index = this.dots.indexOf(dot);

      if (index >= 0) {
        this.selectSlide(index);
      }
    }

    handleBlockSelect(event) {
      const slide = event.target.closest?.("[data-testimonial-slide]");
      const index = this.slides.indexOf(slide);

      if (index >= 0) {
        this.selectSlide(index);
      }
    }

    selectSlide(index, focusDot = false) {
      if (!this.slides[index]) {
        return;
      }

      this.activeIndex = index;

      this.slides.forEach((slide, slideIndex) => {
        slide.hidden = slideIndex !== index;
      });

      this.dots.forEach((dot, dotIndex) => {
        const isActive = dotIndex === index;
        dot.classList.toggle("is-active", isActive);
        dot.setAttribute("aria-current", isActive.toString());
        dot.tabIndex = isActive ? 0 : -1;
      });

      if (focusDot && this.dots[index]) {
        this.dots[index].focus();
      }
    }

    handleDotKeydown(event) {
      const dot = event.target.closest?.("[data-testimonial-dot]");
      const index = this.dots.indexOf(dot);

      if (index < 0) return;

      let nextIndex = index;

      if (event.key === "ArrowLeft") {
        nextIndex = index === 0 ? this.dots.length - 1 : index - 1;
      } else if (event.key === "ArrowRight") {
        nextIndex = index === this.dots.length - 1 ? 0 : index + 1;
      } else if (event.key === "Home") {
        nextIndex = 0;
      } else if (event.key === "End") {
        nextIndex = this.dots.length - 1;
      } else {
        return;
      }

      event.preventDefault();
      this.selectSlide(nextIndex, true);
    }
  }

  customElements.define("formula-testimonial-spotlight", FormulaTestimonialSpotlight);
}
